//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get } from 'vuex-pathify'
import { ChecksLoggedIn, UsesAuthenticatedUser } from '@/mixins'
import { TheFooter, TheHeader } from '~/layouts/components'

export default {
  components: {
    TheFooter,
    TheHeader,
  },
  mixins: [ ChecksLoggedIn, UsesAuthenticatedUser ],
  props: {
    absoluteHeader: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      showBookingModal: false,
      showReviewModal: false,
    }
  },
  head () {
    const onHomePage = this.$route.path === '/'
    return {
      script: onHomePage || window.Stripe
        ? []
        : [
          { hid: 'stripe', src: 'https://js.stripe.com/v3/', async: true, defer: true, body: true },
        ],
    }
  },
  computed: {
    ...get({
      awaitingBookingSession: 'myKintell/awaitingBookingSession',
      awaitingBookingReview: 'myKintell/awaitingBookingReview'
    }),
    onReviewPage () {
      return this.$route.name === 'my-kintell-bookings-id-review'
    },
    // no banner margin if there is something in the beforeFooter slot
    bannerMargin () {
      return !this.$slots['before-footer'] && this.$route.path !== '/'
    },
    pageDisplaysBanner () {
      return this.$route.path === '/search' || // on the search page
        this.$route.path === '/' || // on home page
        this.$route.name === 'advisors-advisor-kintellCard' ||
        this.$route.path === '/become-an-advisor'
    },
    footerHasMargin () {
      // home page never has margin, otherwise check banners
      return !this.pageDisplaysBanner &&
        this.$route.path !== '/' &&
        this.$route.path !== '/code-of-conduct' &&
        this.$route.path !== '/become-an-advisor' &&
        this.$route.path !== '/pricing' &&
        this.$route.path !== '/giftcards' &&
        !this.$slots['before-footer']
    }
  },
  mounted () {
    Object.entries({
      awaitingBookingSession: 'showBookingModal',
      awaitingBookingReview: 'showReviewModal'
    }).forEach(([ prop, data ]) => {
      this.$watch(prop, val => {
        if (val) {
          setTimeout(() => {
            this[data] = true
          }, 2000)
        }
      }, { immediate: true })
    })
  },
}
